import { Modal, Button, Form, Spinner } from "react-bootstrap";
import { RelatorioModalProps } from "./RelatorioModal.Dto";

const RelatorioModal = (props: RelatorioModalProps) => {
  return (
    <Modal show={props.show} onHide={props.onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{props.title || "Selecionar Relatório"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {props.loading && props.relatorios.length === 0 ? (
          <div className="text-center p-3">
            <Spinner animation="border" variant="primary" />
            <p className="mt-2">Carregando relatórios...</p>
          </div>
        ) : props.relatorios.length > 0 ? (
          <Form.Group>
            <Form.Label>Relatório</Form.Label>
            <Form.Select
              value={props.relatorioSelecionado}
              onChange={(e) => props.setRelatorioSelecionado(Number(e.target.value))}
            >
              {props.relatorios.map((rel) => (
                <option key={rel.id} value={rel.id}>
                  {rel.nome}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        ) : (
          <p className="text-center text-muted">Nenhum relatório encontrado para este módulo.</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={props.onHide} disabled={props.loading}>
          Cancelar
        </Button>
        <Button 
          variant="primary" 
          onClick={props.onImprimir} 
          disabled={props.loading || !props.relatorioSelecionado}
        >
          {props.loading ? <Spinner animation="border" size="sm" /> : "Imprimir"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RelatorioModal;
